module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTCS7uCS8tyO9uSTExJdI++kAAAAFdFJOUwBMPyEHLmXD2QAAAHhJREFUKM/d08ENgCAMBdAKDGDrAhAZQI0DGNx/J7ExJrbVeOYf3wHSwge4EhYcQaUgYlaaqtIm0OOZSahjjUI71r4x3RM+Q3UbQSKvzqFOhtnQAZKhBGjlRe0T7NuKofFlCvBq4rXxN/761XYDeHX0s1lQW3gX6wCR2B9ZPF9IugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/upperLeftDecor@3x.png
// module id = 1808
// module chunks = 0